<template>
  <comp :type="1" />
</template>
<script>
import comp from '../component/index'
export default {
  components: { comp }
}
</script>
